import { ArrowLeft } from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom';
import { ReactNode, useEffect } from 'react';
import { Button } from './ui/button';
import { navigateAndScrollTo } from '@/utils/scrollUtils';
interface ServiceLayoutProps {
  title: string;
  description: string;
  icon: ReactNode;
  children: ReactNode;
}
const ServiceLayout = ({
  title,
  description,
  icon,
  children
}: ServiceLayoutProps) => {
  const navigate = useNavigate();

  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-background text-foreground">
      <div className="container px-4 sm:px-6 lg:px-8 mx-auto py-16">
        <div id="content" className="glass-card border-white/10 bg-white/5 p-8 rounded-xl mb-12">
          {children}
        </div>
        
        <div className="text-center max-w-3xl mx-auto mt-16 p-8 glass-card border-white/10 bg-white/5 rounded-xl">
          <h2 className="text-2xl font-bold mb-4">Ready to Get Started?</h2>
          <p className="text-muted-foreground mb-8">Let's discuss how our {title} service can benefit your business.</p>
          <Button className="bg-white hover:bg-gray-200 text-black font-medium px-6 py-6 shadow-lg" asChild>
            <Link to="/consultation">
              Learn More
            </Link>
          </Button>
        </div>
      </div>
    </div>;
};
export default ServiceLayout;